import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: API, withCredentials: true });
